import { render, staticRenderFns } from "./ChatItem.vue?vue&type=template&id=1f2de99a&"
import script from "./ChatItem.vue?vue&type=script&lang=js&"
export * from "./ChatItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports